<template>
    <section class="contact-section">
        <div class="section-container">
            <!-- 联系信息 -->
            <div class="contact-info">
                <h2 class="section-title">智联你我 · 对话未来</h2>
                <div class="divider"></div>
                <p class="section-text">
                    我们能提供“策划+设计+执行”全流程服务的专业团队，可为您量身打造高质量、高性价比、具备切实可执行性的数字创意设计及多媒体解决方案。
                </p>
            </div>

            <!-- 二维码区域 -->
            <div class="qrcode-container">
                <img src="../assets/materials/qrcode.svg" alt="扫描二维码联系我们" class="qrcode">
            </div>

            <!-- 联系详情 -->
            <div class="contact-details">
                <div class="detail-item">
                    <h3 class="detail-title">地址</h3>
                    <p class="detail-content">上海市杨浦区长海路街道佳木斯路2号复旦大学国家大学科技园创新创业基地1号楼302室</p>
                </div>
                <div class="detail-item">
                    <h3 class="detail-title">手机</h3>
                    <p class="detail-content">15000658784（微信同号）</p>
                </div>
                <div class="detail-item">
                    <h3 class="detail-title">邮箱</h3>
                    <p class="detail-content">475927033@qq.com</p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: 'ContactSection'
    }
</script>

<style scoped>
    .contact-section {
        min-height: 60vh;
        padding: 80px 20px 40px;
        background-color: #f9f9f9;
    }

    .section-container {
        max-width: 1200px;
    
        margin: 0 auto;
        display: flex;
        gap: 50px;
        flex-wrap: wrap; /* 允许子元素换行 */
    }

    .contact-info,
    .qrcode-container,
    .contact-details {
        flex: 1 1 300px; /* 每个部分最小宽度为 300px，自动伸缩 */
    }

    /* 默认布局 - PC */
    .contact-info {
        order: 1;
    }

    .qrcode-container {
        order: 2;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .qrcode {
        width: 180px;
        height: 180px;
    }

    .contact-details {
        order: 3;
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 30px;
    }

    .detail-item {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .detail-title {
        font-size: 20px;
        color: #333;
        margin: 0;
    }

    .detail-content {
        font-size: 16px;
        color: #666;
        margin: 0;
    }

    .section-title {
        font-size: 32px;
        color: #333;
        margin-bottom: 20px;
        text-align: center;
    }

    .divider {
        height: 1px;
        background: linear-gradient(to right, transparent, #ccc, transparent);
        margin: 20px 0;
    }

    .section-text {
        font-size: 16px;
        line-height: 1.8;
        color: #666;
    }

    /* 平板设备 */
    @media (max-width: 992px) {
        .section-container {
            flex-direction: row;
            justify-content: space-between;
            align-items: flex-start;
        }

        .contact-info {
            order: 1;
            flex: 1 1 100%;
        }

        .qrcode-container {
            order: 2;
            flex: 0 0 180px;
        }
        .section-title {
            font-size: 24px;
        }
        .contact-details {
            order: 3;
            flex: 1 1 100%;
        }
    }

    /* 手机设备 */
    @media (max-width: 768px) {
        .section-container {
            flex-direction: column;
            align-items: center;
        }

        .qrcode {
            width: 150px;
            height: 150px;
        }

        .contact-info,
        .qrcode-container,
        .contact-details {
            flex: 1 1 100%;
            text-align: center;
        }

        .contact-details {
            margin-top: 20px;
        }

        .section-title {
            font-size: 20px;
        }

        .section-text {
            font-size: 15px;
        }

        .detail-title {
            font-size: 18px;
        }

        .detail-content {
            font-size: 14px;
        }
    }
</style>